import { render, staticRenderFns } from "./EventsListCategories.vue?vue&type=template&id=53fc069e"
import script from "./EventsListCategories.vue?vue&type=script&lang=js"
export * from "./EventsListCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports